import { useApiClient } from "../apiClients";
import { OFFERINGS_ENDPOINTS } from "./endpoints";
import type { SubjectOffering } from "../../models/domain";

export type CreateOfferingPayload = Omit<
  SubjectOffering,
  "id" | "created_at" | "updated_at" | "track_ids"
>;

export type UpdateOfferingPayload = Partial<CreateOfferingPayload>;

export const useOfferingsApi = () => {
  const apiClient = useApiClient("embed");

  const listOfferings = () =>
    apiClient.get<SubjectOffering[]>(OFFERINGS_ENDPOINTS.BASE);

  const getOffering = (offeringId: string) =>
    apiClient.get<SubjectOffering>(OFFERINGS_ENDPOINTS.DETAIL(offeringId));

  const createOffering = (payload: CreateOfferingPayload) =>
    apiClient.post<SubjectOffering>(OFFERINGS_ENDPOINTS.BASE, payload);

  const updateOffering = (
    offeringId: string,
    payload: UpdateOfferingPayload
  ) => apiClient.put<SubjectOffering>(OFFERINGS_ENDPOINTS.DETAIL(offeringId), payload);

  const deleteOffering = (offeringId: string) =>
    apiClient.delete<void>(OFFERINGS_ENDPOINTS.DETAIL(offeringId));

  /** Restreint l'offre à ces filières ; tableau vide = toutes les filières du niveau. */
  const setOfferingTracks = (offeringId: string, trackIds: string[]) =>
    apiClient.put<SubjectOffering>(OFFERINGS_ENDPOINTS.TRACKS(offeringId), {
      track_ids: trackIds,
    });

  return {
    listOfferings,
    getOffering,
    createOffering,
    updateOffering,
    deleteOffering,
    setOfferingTracks,
  };
};
